import { render, staticRenderFns } from "./AppNavInternal.vue?vue&type=template&id=230e0697&scoped=true&"
import script from "./AppNavInternal.vue?vue&type=script&lang=js&"
export * from "./AppNavInternal.vue?vue&type=script&lang=js&"
import style0 from "./AppNavInternal.vue?vue&type=style&index=0&id=230e0697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e0697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})
